import { apiJson } from '@/lib/http';

interface ApiResponse<T> {
  success?: boolean;
  message?: string;
  data?: T;
}

export interface SmsSettingsDto {
    id?: string;
    projectId?: string | null;
    staffPhoneNumber?: string;
    enableStaffSms: boolean;
    staffSmsGroupSize: number;
    reminderTemplate?: string;
    enableClientSms: boolean;
    largePartySmsTemplateFr?: string;
    largePartySmsTemplateEn?: string;
    staffEmail?: string;
    enableStaffEmail: boolean;
    staffEmailGroupSize: number;
}

export interface SmsLogDto {
    id: string;
    toNumber: string;
    content: string;
    sentAt: string;
    status?: string;
    error?: string | null;
    projectId?: string | null;
}

export interface SmsLogPageDto {
    items: SmsLogDto[];
    totalCount: number;
    page: number;
    pageSize: number;
    totalPages: number;
}

const apiCall = async <T>(endpoint: string, options: RequestInit = {}) => apiJson<ApiResponse<T> | T>(endpoint, options);
const unwrap = <T>(res: ApiResponse<T> | T): T => (res as ApiResponse<T>)?.data ?? (res as T);

export const smsService = {
  async getSmsSettings(projectId?: string): Promise<SmsSettingsDto> {
    const endpoint = projectId ? `/Sms?projectId=${encodeURIComponent(projectId)}` : '/Sms';
    const res = await apiCall<SmsSettingsDto>(endpoint);
    return unwrap(res) || { 
        enableStaffSms: false, 
        staffSmsGroupSize: -1,
        enableClientSms: false,
        enableStaffEmail: false,
        staffEmailGroupSize: -1,
        staffEmail: "",
        largePartySmsTemplateFr: "",
        largePartySmsTemplateEn: "",
        staffPhoneNumber: "",
        reminderTemplate: ""
    };
  },

  async updateSmsSettings(settings: SmsSettingsDto, projectId?: string): Promise<SmsSettingsDto> {
    const endpoint = projectId ? `/Sms?projectId=${encodeURIComponent(projectId)}` : '/Sms';
    const res = await apiCall<SmsSettingsDto>(endpoint, {
        method: 'POST',
        body: JSON.stringify(settings)
    });
    return unwrap(res);
  },

  async getSmsLogs(projectId?: string, page: number = 1, pageSize: number = 10): Promise<SmsLogPageDto> {
    const params = new URLSearchParams();
    if (projectId) params.set('projectId', projectId);
    params.set('page', page.toString());
    params.set('pageSize', pageSize.toString());
    const endpoint = `/Sms/logs?${params.toString()}`;
    const res = await apiCall<SmsLogPageDto>(endpoint);
    return unwrap(res) || { items: [], totalCount: 0, page, pageSize, totalPages: 0 };
  }
};

